export default "__VITE_ASSET__fQwVIiC2__"